import React, { useEffect, useState } from "react";
import BannerServ from "../../service/BannerServ";
import SafeImage from "../SafeImage";
import { Carousel } from "antd";
import { useNavigate } from "react-router-dom";
import BannerSkeleton from "../skeletons/BannerSkeleton";
import "../../css/HomeBanner.css";

const HomeBanner = ({ onBannerLoaded }) => {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const res = await BannerServ.index({ screen: 'home', position: 'HOME_RIGHT', platform: 'web' });
                const fetchedBanners = res.data || [];
                setBanners(fetchedBanners);
                onBannerLoaded(fetchedBanners.length > 0);
            } catch (err) {
                console.error("Failed to fetch home right banners", err);
                onBannerLoaded(false);
            } finally {
                setLoading(false);
            }
        };
        fetchBanners();
    }, [onBannerLoaded]);

    if (loading) {
        return (
            <div className="home-banner-container">
                <BannerSkeleton />
            </div>
        );
    }

    if (banners.length === 0) return null;

    const handleBannerClick = (banner) => {
        if (!banner.redirectType || banner.redirectType === 'none') return;

        if (banner.redirectType === 'product' && banner.redirectId) {
            navigate(`/product/${banner.redirectId}`);
        } else if (banner.redirectType === 'category' && banner.redirectId) {
            navigate(`/category/${banner.redirectId}`);
        } else if (banner.redirectType === 'external' && banner.redirectId) {
            window.open(banner.redirectId, '_blank');
        }
    };

    return (
        <div className="home-banner-container" style={{ backgroundColor: "green" }}>
            {banners.length === 1 ? (
                <div onClick={() => handleBannerClick(banners[0])} style={{ height: '100%' }}>
                    <SafeImage src={banners[0].imageUrl} className="home-banner-img" />
                </div>
            ) : (
                <Carousel autoplay dots={{ className: 'slick-dots slick-dots-bottom' }} effect="fade">
                    {banners.map(banner => (
                        <div key={banner._id} onClick={() => handleBannerClick(banner)} style={{ height: '100%' }}>
                            <SafeImage src={banner.imageUrl} className="home-banner-img" />
                        </div>
                    ))}
                </Carousel>
            )}
        </div>
    );
};

export default HomeBanner;
